import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Modal } from "@lookiero/sty-psp-ui";
import { ReturnQuestionProjection } from "../../../../../../../projection/returnQuestion/returnQuestion";
import { returnQuestionHasChildren } from "../../../../../../../projection/returnQuestion/returnQuestion.typeguard";
import { DOMAIN } from "../../../../../i18n/i18n";
import ReturnQuestion from "../../ReturnQuestion";
import { style as modalOptionReturnQuestionItemsStyle } from "./ModalOptionReturnQuestionItems.style";

interface ModalOptionReturnQuestionItemsProps {
  readonly portalHostName?: string;
  readonly returnQuestion: ReturnQuestionProjection;
  readonly returnQuestionParent: ReturnQuestionProjection;
  readonly visible: boolean;
  readonly onClose: () => void;
}

const ModalOptionReturnQuestionItems: FC<ModalOptionReturnQuestionItemsProps> = ({
  portalHostName,
  returnQuestion,
  visible,
  onClose,
}) => {
  const { formatMessage } = useI18n({ domain: DOMAIN });
  const title = formatMessage({ id: returnQuestion.translationKey });

  const style = useMemo(() => modalOptionReturnQuestionItemsStyle(), []);

  return (
    <Modal portalHostName={portalHostName} visible={visible} scroll showCloseButton onClose={onClose}>
      <View style={style.modalContent}>
        <Text level={2} style={style.optionText}>
          {title}
        </Text>
        <>
          {returnQuestionHasChildren(returnQuestion) &&
            returnQuestion.children?.map((childReturnQuestion) => (
              <ReturnQuestion
                key={childReturnQuestion.id}
                portalHostName=""
                returnQuestion={childReturnQuestion}
                returnQuestionParent={returnQuestion}
              />
            ))}
        </>
      </View>
    </Modal>
  );
};

export { ModalOptionReturnQuestionItems };
